export default __webpack_public_path__ + "static/media/banner-bg-apps.cdfa7aa0.png";